import React from 'react';

const CompanyReportFormModal = React.lazy(() => import('../components/FormModal'));
const companyReportModalRegistry = {
    crm_companyReportId: CompanyReportFormModal
};
export default companyReportModalRegistry;
